module.exports = __webpack_public_path__ + "img/d5f43de.svg";